import PropTypes from 'prop-types';

import classes from './ProductIncludes.module.css';

const ProductIncludes = ({ productData }) => {
  return (
    <div className={classes.section}>
      <aside className={classes.productIncludesContainer}>
        <p className={classes.productItem}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/duracion.png"
              alt=""
            />
          </figure>
          <span className={classes.productText}>
            Duración: {productData.duration}{' '}
            {productData.link === 'LEDD' ? 'Años' : 'Semestres'}
          </span>
        </p>
        <p className={classes.productItem}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/materias.png"
              alt=""
            />
          </figure>
          <span className={classes.productText}>
            {productData.subjetcs} Materias
          </span>
        </p>
        <p className={classes.productItem}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/modalidad.png"
              alt=""
            />
          </figure>
          <span className={classes.productText}>
            Modalidad: {productData.modality}
          </span>
        </p>
        <p className={classes.productItem}>
          <figure className={classes.productIcon}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/incioSemestre.png"
              alt=""
            />
          </figure>
          <span className={classes.productText}>
            Inicio{' '}
            {productData.link === 'LEDD'
              ? 'cuatrimestral'
              : 'semestral'}
            : {productData.start}
          </span>
        </p>
      </aside>
    </div>
  );
};

ProductIncludes.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default ProductIncludes;
